export function appendTitle(className, title) {
    $(className).find('.modal-header > h4').append(`<div class="pull-right"><span id="history-title">${title}&nbsp;&nbsp;</span></div>`);
}

export function showModal(className) {
    const body = $('body');
    $(className).modal('toggle')
        .on('hidden.bs.modal', function () {
            $(this).remove();
            body.find('.bs-container').remove();
        })
        .on('hide.bs.modal', function () {
            $(this).remove();
            body.find('.bs-container').remove();
        });
    $(className).on('shown.bs.modal', () => {
        $(document).off('focusin.modal');
    });
}

export function promiseConfirm(text, title, closeText, nextText, sizeModalClass, smallBtn) {
    return new Promise((resolve) => {
        confirmModal(text, title, closeText, nextText, sizeModalClass, smallBtn);
        $('.confirm-modal .confirm-success').on('click', () => {
            $('.confirm-modal').modal('hide');
            resolve();
        });
    });
}

export function confirmModal(text, title, closeText, successText, sizeModalClass = 'modal-sm', smallBtn = true) {
    if (title === undefined) {
        title = 'Подтверждение';
    }

    const btnSizeClass = smallBtn ? 'btn-sm' : 'btn-md';

    const body = $('body');
    body.append(`${'<div class="modal fade confirm-modal" aria-hidden="true" style="display: none;">'
        + '<div class="modal-dialog '}${sizeModalClass}"><div class="modal-content">`
        + '<div class="modal-header">'
        + '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + `</button><h4 class="modal-title">${title}</h4></div>`
        + `<div class="modal-body">${text}</div>`
        + '<div class="modal-footer">'
        + `<button type="button" class="btn btn-default ${btnSizeClass}" data-dismiss="modal">${closeText}</button>${
            successText ? (`<button type="button" class="confirm-success btn btn-primary ${btnSizeClass}">${successText}</button>`) : ''
        }</div></div></div></div>`);
    showModal('.confirm-modal');
}
